<template>
  <div>
    <div class="t_neiban">
      <div class="t_b1banpic flex-row-center">
        <div class="nesc_cont1360 nesc_pos_bot animate__animated animate__fadeInUp">
          <h2 class="nesc_inban_title">{{ $t('lang.productionOffice') }}</h2>
        </div>
      </div>
    </div>

    <div class="padding-bottom">
      <el-header>
        <h3 class="nesc_title40">{{ $t('lang.productionOffice') }}</h3>
      </el-header>

      <el-carousel class="nesc_cont1360 el-carousel_pc" arrow="always" type="card" :autoplay="autoplay">
        <el-carousel-item v-for="(item, index) in imageList" :key="index">
          <el-row>
            <el-col :span="24">
              <img ref="bannerHeight" :src="require('../../assets/image/shengchan/shengchan'+item+'.jpg')" style="width: auto;height: 300px" object-fit="contain" @load="imgLoad">
            </el-col>
          </el-row>
        </el-carousel-item>
      </el-carousel>

      <el-carousel class="el-carousel_phone" direction="vertical" height="250px" arrow="always" :autoplay="autoplay">
        <el-carousel-item v-for="(item, index) in imageList" :key="index">
          <el-row>
            <el-col :span="24">
              <img ref="bannerHeight" :src="require('../../assets/image/shengchan/shengchan'+item+'.jpg')" style="width: 100%;height: 250px" object-fit="contain" @load="imgLoad">
            </el-col>
          </el-row>
        </el-carousel-item>
      </el-carousel>

      <!--
      <div class="flex-column-center ph-production-office">
        <swiper ref="mySwiper1" class="swiper1 nesc_cont1360" :options="swiperOption1">
          <swiper-slide class="slide" v-for="(item, index) in imageList" :key="index">
            <img :src="require('../../assets/image/shengchan/shengchan'+item+'.jpg')" >
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      -->

      <el-header>
        <h3 class="nesc_title40">{{ $t('lang.cellProductionLine') }}</h3>
      </el-header>

      <swiper ref="mySwiper" class="swiper nesc_cont1360" :options="swiperOption">
        <swiper-slide v-for="(item, index) in 12" :key="index" class="slide">
          <img :src="require('../../assets/image/cell/'+item+'.jpg')" class="swiper-lazy">
        </swiper-slide>
        <div slot="pagination" class="swiper-pagination" />
      </swiper>
    </div>

  </div>
</template>

<script>
export default {
  name: 'ProductionOffice',
  data: () => {
    return {
      autoplay: !0,
      bannerHeight: '',
      swiperOption: {
        slidesPerView: 'auto',
        autoHeight: true,
        spaceBetween: 10,
        freeMode: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      swiperOption1: {
        slidesPerGroup: 1,
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        loopFillGroupWithBlank: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      imageList: [1, 3, 4]
    }
  },

  mounted() {
    this.imgLoad()
    window.addEventListener('resize', () => {
      this.imgLoad()
    }, false)
  },

  methods: {
    imgLoad() {
      this.$nextTick(() => {
        const ref = this.$refs
        this.bannerHeight = ref.bannerHeight && ref.bannerHeight.length ? ref.bannerHeight[0].height : ''
      })
    }
  }

}
</script>

<style scoped lang="scss">
.el-header {
  height: auto !important;
  @media screen and (max-width: 991px){
    margin-top: 40px;
    margin-bottom: 20px;
  }
  @media screen and (max-width: 768px){
    margin-top: 30px;
    margin-bottom: 20px;
  }
}

.el-carousel_pc {
  .el-carousel__item {
    @media screen and (max-width: 991px){
      width: 70%;
      left: -5%;
    }
    @media screen and (max-width: 768px){
      width: 80%;
      left: -15%;
    }
  }
}

@media screen and (max-width: 600px){
  /*.ph-production-office {display: block};*/
  .el-carousel_pc {display: none};
  .el-carousel_phone {display: block};
}

@media screen and (min-width: 601px){
  /*.ph-production-office {display: none}; */
  .el-carousel_pc {display: block};
  .el-carousel_phone {display: none};
}

.t_neiban {
  position: relative;
  width: 100%;
  .t_b1banpic {
    width: 100%;
    position: relative;
    height: 300px;
    @media screen and (max-width: 768px) {
      height: 200px;
    }
    background: url("../../assets/image/shengchan/shengchan5.png") center/cover no-repeat;
    .nesc_pos_bot {
      .nesc_inban_title {
        font-size: 72px;
        line-height: 1.45;
        font-weight: bold;
        font-family: "OPPOSans2_En_design-Heavy", "OPPOSans2_En_design-Regular", "微软雅黑", Arial, "PingFangSC-Light", "Helvetica Neue", Helvetica, "Microsoft Yahei", "Hiragino Sans GB", tahoma, SimSun, sans-serif;
        color: #fff;
        @media screen and (max-width: 1680px) {
          font-size: 64px;
        }
        @media screen and (max-width: 1440px) {
          font-size: 48px;
        }
        @media screen and (max-width: 768px) {
          font-size: 28px;
        }
      }
    }
  }

}

/*
.swiper1 {
  .swiper-slide {
    text-align: center;
    position: relative;
    width: 80%;
    height: 280px;
    img {
      width: 100%;
      height: auto;
      max-width: 100%;
      max-height: 100%;
      transform: translate(-50%, -50%);
      position: absolute;
      left: 50%;
      top: 50%;
    }
  }
}
*/

.swiper {
  .swiper-slide {
    text-align: center;
    position: relative;
    width: 250px;
    height: 240px;
    img {
      width: auto;
      height: 200px;
      max-width: 100%;
      max-height: 100%;
    }
  }
  ::v-deep .swiper-pagination-bullet {
    background:#C0C4CC;
    opacity: .24;
  }
  ::v-deep .swiper-pagination-bullet-active {
    background:#C0C4CC;
    opacity: 1;
  }

}

</style>
